<template>
  <v-dialog v-model="dialog" max-width="300">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>Your Search Request</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        There were no records found that match your search criteria. Please try
        again.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat="flat" @click="dialog = false">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NoResults',
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    dialog(val) {
      if (!val) return;

      setTimeout(() => (this.dialog = false), 3000);
    },
  },
};
</script>
